module.exports = __webpack_public_path__ + "static/media/080-taiwan.dc169005.svg";